export default __webpack_public_path__ + "static/media/logo14.e1ddf05e.svg";